module.exports = function () {
    $(document).ready(function () {

        var helper = require('../../helper');
        var AjaxController = require('../../services/AjaxController');

        $(document).on('click', '.btn-void', function(e){

            var $this = $(this),
                expenditureId = $this.data('expenditure-id'),
                url = '/api/expenditures/toggle-void';

            var data = {
                expenditureId: expenditureId,
            };
            var success = function (response) {
                if (response['new_status'] == 0) {
                    $this.removeClass('btn-void-yellow');
                    $this.addClass('btn-void-white');
                } else {
                    $this.removeClass('btn-void-white');
                    $this.addClass('btn-void-yellow');
                }
            }
            var error = function (response) {
                //console.log('Error');
            }

            AjaxController.prototype.send(url, data, success, error);
        });


    });
}();
